import * as React from 'react';

import { setLocation } from 'js/lib/coursera.redirect';

import { Button } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';
import { useEnterpriseBadgeMetadata } from 'bundles/unified-home-common/contexts/EnterpriseBadgeMetadataContext';

import _t from 'i18n!nls/course-cards';

const SkillPathwayTakeAssessmentButton = ({ courseId }: { courseId: string }) => {
  const program = useProgram();
  const thirdPartyOrganization = useThirdPartyOrganization();
  const track = useTracker();
  const badgeMetadata = useEnterpriseBadgeMetadata();

  // Find the assessment item ID for the matching course
  const matchingSkillArea = badgeMetadata?.skillPathway?.skillAreasWithUserData?.find(
    (skillAreaWithUserData) => skillAreaWithUserData.skillArea.course.id === courseId
  );

  if (!matchingSkillArea?.skillArea?.course) {
    return null;
  }

  const onClick = () => {
    track('click_button', {
      button: {
        name: 'skill_pathway_skill_area_take_assessment',
      },
      enterprise: {
        ...(thirdPartyOrganization?.slug ? { organizationSlug: thirdPartyOrganization?.slug } : {}),
        ...(program?.slug ? { programSlug: program?.slug } : {}),
      },
      product: {
        id: courseId,
        type: 'course',
      },
    });

    setLocation(
      `/learn/${matchingSkillArea.skillArea.course.slug}/assignment-submission/${matchingSkillArea.assessmentItemId}`
    );
  };

  return (
    <Button variant="ghost" size="small" style={{ marginTop: '12px' }} onClick={onClick}>
      {_t('Take assessment')}
    </Button>
  );
};

export default SkillPathwayTakeAssessmentButton;
